<template>
  <div class="card">
    <div class="card-body">
      <form @submit.prevent>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label font-weight-bold">Interview Type</label>
          <div class="col-sm-9">
            <input type="text" class="form-control-plaintext" readonly :value="testDisplayName" />
          </div>
        </div>
      </form>
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Category</th>
              <th class="text-center">Emphasize</th>
            </tr>
          </thead>
          <tbody>
            <tr colspan="12" v-if="loadingMessage" class="text-muted text-center">
              <td colspan="12">
                {{ loadingMessage }}
              </td>
            </tr>
            <tr v-for="category in categories" :key="category.id">
              <td>
                <span class="pt-2">{{ category.displayName }}</span>
              </td>
              <td class="text-center">
                <span v-if="category.isEmphasized" class="pt-2"><fa icon="check"/></span>
                <span v-if="!category.isEmphasized" class="pt-2 text-muted">---</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    organizationId: String,
    interviewId: String,
  },
  data() {
    return {
      loadingMessage: null,
      interview: null,
    };
  },
  computed: {
    testDisplayName() {
      return this.interview && this.interview.test ? this.interview.test.displayName : null;
    },
    categories() {
      return this.interview && this.interview.categories ? this.interview.categories : [];
    },
  },
  watch: {
    interviewId() {
      if (this.interviewId) {
        this.getInterview();
      } else {
        this.interview = null;
      }
    },
  },
  methods: {
    getInterview() {
      this.loadingMessage = "Loading...";
      this.$axios
        .get(`/v1/organizations/${this.organizationId}/interviews/${this.interviewId}/attributes`)
        .then(res => (this.interview = res.data))
        .catch(() => this.$router.push("/404"))
        .finally(() => (this.loadingMessage = null));
    },
  },
};
</script>
